import {Routes} from '@angular/router';
import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {PortalService} from '../services/portal.service';
import {StepChapterComponent} from '../step/step.chapter.component';
import {EinstiegComponent} from "./einstieg/einstieg.component";
import {EingabeStepComponent} from "./eingabe/eingabe.step.component";
import {ErgebnisComponent} from "./ergebnis/ergebnis.component";
import {EingabeAusstiegComponent} from "./eingabe/eingabe.ausstieg.component";
import {EingabeRoofAreaComponent} from "./eingabe/eingabe.roof-area.component";
import {PhotovoltaikcheckAnfrage} from "./anfrage/photovoltaikcheck.anfrage";

/**
 * Routes for the photovoltaikcheck.
 */
const routes: Routes = [
  {
    path: ':portalId/photovoltaikcheck', children: [
      // entry page
      {path: 'einstieg', component: EinstiegComponent, data: {path: PhotovoltaikcheckAnfrage.PATH_ALL}},
      {path: 'einstieg/balkon', component: EinstiegComponent, data: {path: PhotovoltaikcheckAnfrage.PATH_BALCONY}},
      {path: '', redirectTo: 'einstieg', pathMatch: 'full'},

      // input section
      {path: 'eingabe', component: StepChapterComponent, children: [
          {path: 'basisdaten/1', component: EingabeStepComponent, data: {swipeCount: '10'}},
          {path: 'basisdaten/2', component: EingabeStepComponent, data: {swipeCount: '11'}},
          {path: 'basisdaten/3', component: EingabeStepComponent, data: {swipeCount: '12'}},
          {path: 'stromverbrauch/1', component: EingabeStepComponent, data: {swipeCount: '20'}},
          {path: 'stromverbrauch/2', component: EingabeStepComponent, data: {swipeCount: '21'}},
          {path: 'stromverbrauch/3', component: EingabeStepComponent, data: {swipeCount: '22'}},
          {path: 'aufstellort/1', component: EingabeStepComponent, data: {swipeCount: '30'}},
          {path: 'aufstellort/2', component: EingabeStepComponent, data: {swipeCount: '31'}},
          {path: 'aufstellort/3', component: EingabeRoofAreaComponent, data: {swipeCount: '32'}},

          {path: 'ausstieg', component: EingabeAusstiegComponent, data: {swipeCount: '39', ignoreInNav: true, isDeadEnd: true}},

          {path: '', redirectTo: 'basisdaten/1', pathMatch: 'full'},
        ]
      },

      // result page
      {path: 'ergebnis', component: StepChapterComponent, children: [
          {path: 'uebersicht', component: ErgebnisComponent, data: {swipeCount: '40'}},

          {path: '', redirectTo: 'uebersicht', pathMatch: 'full'},
        ]
      },
    ]
  },

  // default redirects
  {path: ':portalId', redirectTo: PortalService.defaultPortal + '/photovoltaikcheck', pathMatch: 'full'},
  {path: 'photovoltaikcheck/', redirectTo: PortalService.defaultPortal + '/photovoltaikcheck', pathMatch: 'full'},
  {path: '', redirectTo: PortalService.defaultPortal + '/photovoltaikcheck', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollOffset: [0, 150],
    paramsInheritanceStrategy: 'always'
})],
  exports: [RouterModule]
})
export class PhotovoltaikcheckRoutingModule {
}
